import React from 'react';
import Autosuggest from 'react-autosuggest';
// import './rating.css';
import './autosuggest.css';

function escapeRegexCharacters (str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function getSuggestions (suggestions, value) {
  const escapedValue = escapeRegexCharacters(value.trim());

  if (escapedValue === '') {
    return [];
  }

  const regex = new RegExp('' + escapedValue, 'i');
  return suggestions.filter(suggestion => regex.test(suggestion.label));
}

function getSuggestionValue (suggestion) {
  return suggestion.label;
}

function renderSuggestion (suggestion) {
  return (
    <span>{suggestion.label}</span>
  );
}

const AutoSuggestField = props => {
  const [fieldProps, setFieldProps] = React.useState({
    locked: false,
    focussed: false,
    error: '',
    label: props.label,
    placeholder: props.placeholder,
    suggestions: []
  });

  // const fieldClassName = `rating-input-field ${(fieldProps.locked ? fieldProps.focussed : fieldProps.focussed || fieldProps.value) && 'focussed'} ${fieldProps.locked && !fieldProps.focussed && 'locked'}`;

  const onChange = (event, { newValue, method }) => {
    props.setValue(newValue);
  };

  const onSuggestionsFetchRequested = ({ value }) => {
    setFieldProps(old => ({ ...old, suggestions: getSuggestions(props.suggestions, value) }));
  };

  const onSuggestionsClearRequested = () => {
    setFieldProps(old => ({ ...old, suggestions: [] }));
  };

  const inputProps = {
    placeholder: props.placeholder,
    value: props.value,
    onChange: onChange,
    onFocus: () => !fieldProps.locked && setFieldProps(old => ({ ...old, focussed: true })),
    onBlur: () => !fieldProps.locked && setFieldProps(old => ({ ...old, focussed: false })),
    id: props.label
  };

  const fieldClassName = `input-field${props.small ? ' smaller' : ''}${(fieldProps.focussed || fieldProps.value) ? ' focussed' : ''}${props.value !== '' ? ' filled' : ''}`;

  return (
    <div>
      <div className={fieldClassName}>
        <Autosuggest
          suggestions={fieldProps.suggestions}
          onSuggestionsFetchRequested={onSuggestionsFetchRequested}
          onSuggestionsClearRequested={onSuggestionsClearRequested}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          inputProps={inputProps}
        />
        <label htmlFor={props.label} className={fieldProps.error && 'error'}>
          {fieldProps.error || fieldProps.label}
        </label>
      </div>
    </div>
  );
};
export default AutoSuggestField;
